import { render, staticRenderFns } from "./BalanceManagement.vue?vue&type=template&id=670106c1&scoped=true"
import script from "./BalanceManagement.vue?vue&type=script&lang=js"
export * from "./BalanceManagement.vue?vue&type=script&lang=js"
import style0 from "./BalanceManagement.vue?vue&type=style&index=0&id=670106c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670106c1",
  null
  
)

export default component.exports